import { createAction } from '@reduxjs/toolkit';
import { DeliveryAddress } from '../models/address';
import { IDeliveryZone } from '../models/organizationInfo/deliveryTerminal/deliveryZone.model';

export const SET_CURRENT_ADDRESS = '[State] SET_CURRENT_ADDRESS';
export const UPDATING_CURRENT_ADDRESS = '[State] UPDATING_CURRENT_ADDRESS';

/**
 * @deprecated
 */
export const setCurrentAddressAction = createAction<{
  organizationCode: string,
  deliveryAddress: DeliveryAddress | null,
  deliveryZone: IDeliveryZone | null
}>(SET_CURRENT_ADDRESS);

/**
 * @deprecated
 */
export const updatingCurrentAddressAction = createAction<{
  deliveryAddress: DeliveryAddress | null,
  deliveryZone: IDeliveryZone | null
}>(UPDATING_CURRENT_ADDRESS);
